import React, { forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import { ArrowIcon } from '../icons';
import { BaseButton } from '../button';
import { Caption } from '../caption';
import { Icon } from '../icon';
import { Typography } from '../typography';
import { MenuButton } from '../menu';
import cssStyles from './styles/base.module.css';
export const DropdownButton = /*#__PURE__*/forwardRef(({
  open,
  setOpen,
  mobile,
  disabled,
  size,
  rootStyle,
  showValue,
  currentValue,
  placeholder,
  label,
  warning,
  caption,
  error
}, ref) => {
  const fieldClassname = useMemo(() => clsx(cssStyles.field, {
    [cssStyles.fieldWithLabel]: !!label
  }), [label]);
  const buttonProps = useMemo(() => ({
    ref,
    className: `${cssStyles.button} ${cssStyles.dropdown}`,
    tabIndex: open || disabled ? -1 : 0,
    onClick: () => disabled ? null : setOpen(!open),
    children: (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      className: cssStyles.title,
      "data-testid": "dropdown-value",
      size: "body_long",
      variant: size === 'l' ? 'm' : 's'
    }, showValue !== undefined || showValue === true ? currentValue : placeholder), /*#__PURE__*/React.createElement(Icon, {
      size: size === 's' ? 16 : 20,
      className: cssStyles.arrow,
      color: "text-primary"
    }, /*#__PURE__*/React.createElement(ArrowIcon, {
      direction: open ? 'top' : 'bottom'
    })), /*#__PURE__*/React.createElement("fieldset", {
      className: fieldClassname
    }, label && /*#__PURE__*/React.createElement("legend", {
      className: cssStyles.legend
    }, label))))
  }), [ref, open, disabled, size, showValue, currentValue, placeholder, fieldClassname, label, setOpen]);
  return /*#__PURE__*/React.createElement("div", {
    className: rootStyle
  }, !!mobile ? /*#__PURE__*/React.createElement(BaseButton, {
    ...buttonProps
  }) : /*#__PURE__*/React.createElement(MenuButton, {
    wide: true,
    ...buttonProps
  }), caption && (/*#__PURE__*/React.createElement(Caption, {
    className: cssStyles.caption,
    captionSize: size,
    error: error,
    warning: warning,
    message: caption
  })));
});